<div class="rrw-container">
  @if (presentation?.hasData) {
    @for (chunk of presentation!.chunks; track trackByIndex($index)) {
      <div [style]="styles.chunk">
        <table [style]="styles.table">
          <thead>
            <tr>
              <th [style]="styles.headerCell">{{ presentation!.segCodeLabel }}</th>
              <th [style]="styles.headerCell">{{ presentation!.segNameLabel }}</th>
              <th [style]="styles.headerCell">{{ presentation!.workersLabel }}</th>
              <th [style]="styles.headerCell">{{ presentation!.contractorsLabel }}</th>
              @for (col of chunk.columns; track trackByIndex($index)) {
                <th [style]="styles.headerCell"
                  >
                  <div>{{ col.agentName }}</div>
                  <div [style]="styles.consequence">{{ presentation!.consequenceRatingLabel }} {{ col.consequenceRating }}</div>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of chunk.rows; track trackByIndex($index)) {
              <tr>
                <td [style]="styles.fixedCell">{{ row.segCode }}</td>
                <td [style]="row.segNameStyle">{{ row.segName }}</td>
                <td [style]="styles.fixedCell">{{ row.numberOfWorkers }}</td>
                <td [style]="styles.fixedCell">{{ row.numberOfContractors }}</td>
                @for (cell of row.cells; track trackByIndex($index)) {
                  <td
                  [style]="styles.matrixCell + cell.cellStyle">{{ cell.statText }}</td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    <div [style]="styles.legend">
      @for (item of presentation!.legendItems; track trackByIndex($index)) {
        <span [style]="styles.legendItem"
          >
          <span [style]="styles.swatch + item.swatchStyle"></span>
          <span>{{ item.label }}</span>
        </span>
      }
    </div>
    <div [style]="styles.footer">{{ presentation!.footerLabel }}</div>
  } @else {
    <p class="rrw-no-data">{{ noDataLabel }}</p>
  }
</div>
